import { Post } from "services/apiService";
import { CREATE_PROCESS_ORDERS_REQUEST, CREATE_PROCESS_ORDERS_SUCCESS, CREATE_PROCESS_ORDERS_ERROR, RESET_PROCESS_ORDERS } from "redux/actions/action-type";
import { BASE_URL, SOMS_API_KEY } from "services/CONSTANTS";
import { encryptString } from "components/common/EncryptDecrypt";

export const createProcessOrder = ({ orders, action }) => async (dispatch) => {

    let email = "";
    const sessionData = sessionStorage.getItem("persist:root");

    if (sessionData) {
        const parsedData = JSON.parse(sessionData);
        const userData = JSON.parse(parsedData.user);
        email = userData.loginResponse.email;
    }
    const encryptedEmailId =await encryptString(email);

    const apiUrl = `${BASE_URL}orders/@processorders?orderType=central-supplychain&action=${action}&apikey=${SOMS_API_KEY}`;

    const requestBody = { orders: orders, "userId": encryptedEmailId };
    dispatch({ type: CREATE_PROCESS_ORDERS_REQUEST })

    Post({
        url: apiUrl,
        params: requestBody,
        config: {}
    }).then(response => {
        if (response.status === 200) {
            dispatch({
                type: CREATE_PROCESS_ORDERS_SUCCESS,
                payload: response.data,
            });
        } else {
            dispatch({
                type: CREATE_PROCESS_ORDERS_ERROR,
                payload: response.data || 'Error occurred while fetching orders.',
            });
        }
    })
        .catch(error => {
            dispatch({
                type: CREATE_PROCESS_ORDERS_ERROR,
                payload: error.response.data || 'An error occurred while fetching data.',
            });
        })

}
export const resetOrderCreateProcessOrders = () => {
    return {
        type: RESET_PROCESS_ORDERS
    };
};
